import { Box, TabPanels, TabPanel, TabPanelProps } from '@chakra-ui/react'

import {
  DetailDrawerHeader,
  DetailDrawerSummary,
  DetailDrawerTabs,
} from 'modules/DetailDrawer'

import TableView from 'routes/apps/TableView'
import { useAppRoute } from 'routes/utils'

import { SlideOver } from 'components'

import { IResponseBase } from 'api/types'

import { IModel } from 'interfaces/model.interface'
import { ViewData } from 'interfaces/navigationPage.interface'

import { apps } from 'config/apps'
import {
  CardioLipidPublicationsModel,
  CardioLipidTrialsModel,
  CardioLipidMediaModel,
  CardioLipidPressReleasesModel,
  CardioLipidConferencePresentationsModel,
} from 'config/apps/Cardio/Science360/LipidLoweringTherapies/CardioLipidModel'
import { CardioCandidateData } from 'config/common/baseModel/cardio360/Cardio360Candidate'

const StyledTabPanel: React.FC<React.PropsWithChildren<TabPanelProps>> = (
  props
) => <TabPanel height='100%' display='flex' flexDir='column' p={0} {...props} />

type PropTypes<D extends Record<CardioCandidateData, any>> = {
  handleClose: () => void
  candidate: IResponseBase<Extract<keyof D, string>>
  model: IModel<D>
  title: Extract<keyof D, string>
  viewData: ViewData
}

function Detail<D extends Record<CardioCandidateData, any>>(
  props: PropTypes<D>
) {
  const { handleClose, candidate, model, title, viewData } = props

  const app = useAppRoute()

  const exportName = (modelTarget: IModel<any>) =>
    `${apps[app].name}_${model.name}_${candidate && candidate[title]}_${
      modelTarget.name
    }`

  return (
    <SlideOver show={true} width='80vw' handleClose={handleClose}>
      <DetailDrawerHeader
        isLoading={false}
        title={candidate && candidate[title]}
        handleClose={handleClose}
      />
      <DetailDrawerTabs
        tabs={[
          'Summary',
          'Publication',
          'Trials',
          'Media',
          'Press Releases',
          'Conference Presentations',
        ]}
      >
        <Box flexGrow={1} flexBasis={0} overflow='hidden'>
          <TabPanels height='100%'>
            <StyledTabPanel p={6} overflow='auto'>
              <DetailDrawerSummary rowData={candidate} model={model} />
            </StyledTabPanel>
            <StyledTabPanel>
              <TableView
                id={1}
                viewData={viewData}
                model={CardioLipidPublicationsModel}
                ids={candidate.lookupCandidatePublications}
                exportName={exportName(CardioLipidPublicationsModel)}
              />
            </StyledTabPanel>
            <StyledTabPanel>
              <TableView
                id={2}
                viewData={viewData}
                model={CardioLipidTrialsModel}
                ids={candidate.lookupCandidateClinicalTrials}
                exportName={exportName(CardioLipidTrialsModel)}
              />
            </StyledTabPanel>
            <StyledTabPanel>
              <TableView
                id={3}
                viewData={viewData}
                model={CardioLipidMediaModel}
                ids={candidate.lookupCandidateMediaArticles}
                exportName={exportName(CardioLipidMediaModel)}
              />
            </StyledTabPanel>
            <StyledTabPanel>
              <TableView
                id={4}
                viewData={viewData}
                model={CardioLipidPressReleasesModel}
                ids={candidate.lookupPressReleases}
                exportName={exportName(CardioLipidPressReleasesModel)}
              />
            </StyledTabPanel>
            <StyledTabPanel>
              <TableView
                id={5}
                viewData={viewData}
                model={CardioLipidConferencePresentationsModel}
                ids={candidate.conferencePresentations}
                exportName={exportName(CardioLipidConferencePresentationsModel)}
              />
            </StyledTabPanel>
          </TabPanels>
        </Box>
      </DetailDrawerTabs>
    </SlideOver>
  )
}

export default Detail
